export default "__VITE_ASSET__47a52b44__"